<template>
	<div class="auth-container">
		<img src="@/assets/logo.svg" alt="CIL Logo" class="logo" />
		<br />
		<br />

		<!-- Carte pour indiquer que le partage n'existe pas -->
		<div v-if="errorMessage === 'Partage non trouvé'" class="card white" style="text-align: center">
			<h2>Partage non trouvé</h2>
			<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png" alt="Partage non trouvé" />
		</div>

		<!-- Carte pour demander le mot de passe -->
		<div v-if="protect || errorMessage === 'Mot de passe invalide'" class="card white">
			<div class="form-control">
				<label for="password">Mot de passe</label>
				<input type="password" id="password" v-model="password" />
			</div>
			<div v-if="errorMessage" class="message">{{ errorMessage }}</div>
			<button @click="checkPassword" class="button fill normal">Accéder</button>
		</div>

		<!-- Carte pour afficher le partage -->
		<div v-if="!protect && errorMessage !== 'Partage non trouvé' && errorMessage !== 'Mot de passe invalide' && share.share"
			class="card white">
			<h2>{{ share.share.name }}</h2>
			<div class="form-control">
				<div v-if="share.shareFiles">
					<p>Fichiers:</p>
					<div v-for="file in share.shareFiles" :key="file.ID" class="file-entry">
						<i class="bi bi-file-pdf-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<i class="file-icon bi bi-download" @click="downloadFile(file.ID)"></i>
						<i class="file-icon bi bi-eye-fill" @click="viewFile(file.ID)"></i>
					</div>
				</div>
			</div>
		</div>

		<p>{{ errorMessage }}</p>

		<a href="https://mondomicil.fr" class="link backto">Découvrir mondomicil.fr</a>
	</div>
</template>

<script>
export default {
	name: "SharePage",
	data() {
		return {
			shareID: this.$route.params.shareID,
			share: {},
			errorMessage: "",
			password: "",
			protect: false,
		};
	},
	created() {
		this.shareID = this.$route.params.shareID || this.$route.query.shareID;
		this.fetchShare();
	},
	methods: {
		async fetchShare() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/i/" + this.shareID, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.message === "Partage not found") {
					this.errorMessage = "Partage non trouvé";
				} else if (data.protect === true) {
					this.protect = true;
				} else {
					this.share = data;
				}
			} catch (error) {
				this.errorMessage = "Une erreur est survenue.";
			}
		},
		async checkPassword() {
			try {
				const body = JSON.stringify({ password: this.password });
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/i/" + this.shareID + "/password", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include", body, });
				const data = await response.json();
				if (data.protect === true) {
					this.protect = true;
					this.errorMessage = "Mot de passe invalide.";
				} else {
					this.protect = false;
					this.share = data;
				}
			} catch (error) {
				this.errorMessage = "Une erreur est survenue.";
			}
		},
		viewFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "partages/fichier/read/" + fileId;
			window.open(url, "_blank");
		},
		downloadFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "partages/fichier/download/" + fileId;
			window.open(url, "_blank");
		},
	},
};
</script>

<style></style>
